import { Platform } from 'react-native';

import { TechnicalDeviceType } from 'store/railsBuilder/reducer.types';

import { isSafari } from 'utils/responsiveness';

export const TECHNICAL_DEVICE_TYPE = Platform.select<TechnicalDeviceType>({
    ios: TechnicalDeviceType.ios,
    android: TechnicalDeviceType.android,
    web: isSafari ? TechnicalDeviceType.ios : TechnicalDeviceType.web,
    default: TechnicalDeviceType.ios,
});
